import { z } from 'zod';

import { FiscalOperationDefinitionItemSchema } from './operation-catalog.schemas.js';

export const RegisterFiscalOperationDefinitionBodySchema = z.looseObject({
  code: z.string().min(1).max(50),
  name: z.string().min(1),
  operationNature: z.string().min(1).max(60),
  direction: z.enum(['INBOUND', 'OUTBOUND']),
  operationKind: z.enum([
    'SALE',
    'PURCHASE',
    'RETURN',
    'TRANSFER',
    'REMITTANCE',
    'SERVICE',
    'WARRANTY',
    'BONUS',
    'INTERNAL_CONSUMPTION',
    'ADJUSTMENT',
  ]),
  documentKind: z.enum(['NFE', 'NFCE', 'NFSE', 'CTE', 'MDFE', 'EXTERNAL']),
  defaultCfopCode: z.string().length(4).nullable().optional(),
  verticalScope: z.string().max(30).nullable().optional(),
  validFrom: z.iso.date().optional(),
  validUntil: z.iso.date().nullable().optional(),
});

export const UpdateFiscalOperationDefinitionBodySchema = z.looseObject({
  name: z.string().min(1).optional(),
  operationNature: z.string().min(1).max(60).optional(),
  defaultCfopCode: z.string().length(4).nullable().optional(),
  verticalScope: z.string().max(30).nullable().optional(),
  validUntil: z.iso.date().nullable().optional(),
});

export const FiscalOperationDefinitionCodeParamsSchema = z.looseObject({
  code: z.string().min(1).max(50),
});

export const FiscalOperationDefinitionResponseSchema = FiscalOperationDefinitionItemSchema;

export type RegisterFiscalOperationDefinitionBody = z.infer<
  typeof RegisterFiscalOperationDefinitionBodySchema
>;
export type UpdateFiscalOperationDefinitionBody = z.infer<
  typeof UpdateFiscalOperationDefinitionBodySchema
>;
